import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-select-filter.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-select-filter.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import * as RecipientListFilterConstants from "../../recipient-list/recipient-list-filter/recipient-list-filter.constants";
import { RecipientSettingsService } from "../../../../core/settings/components/recipients/shared/recipient-settings.service";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../models/alert";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddNewRecipientComponent } from "../shared/add-new-recipient/add-new-recipient.component";
import { SharedConstants } from "../../../constants/shared.constants";
import { RequestStatusService } from "../../../services/request-status/request-status.service";
let RecipientSelectFilterComponent = class RecipientSelectFilterComponent {
    changeDetectorRef;
    recipientSettingsService;
    appControllerService;
    requestStatusService;
    modalService;
    stepMetaRecipientGroups;
    configurableLabel;
    disableAddRecipientBtn;
    jobId;
    loadRecipient = new EventEmitter();
    checkIfDisableStatus = new EventEmitter();
    displayGroupsPlaceTextHolder = RecipientListFilterConstants.DISPLAY_GROUPS_TEXT_PLACEHOLDER;
    selectGroupsPlaceTextHolder = RecipientListFilterConstants.SELECT_GROUPS_TEXT_PLACEHOLDER;
    selectedGroupOptions = [SharedConstants.FILTER_DEFAULT];
    configurableLabelPlaceholder = RecipientListFilterConstants.DEFAULT_RECIPIENT_LABEL;
    selectedRecipientOptions = [];
    displayFilterGroups;
    addBtnPlaceholder;
    addAllBtnPlaceholder = RecipientListFilterConstants.ADD_ALL_GROUPS_BTN_PLACEHOLDER;
    selectedRecipientFromDropdown;
    noRecipientSelectedErrMsg = RecipientListFilterConstants.NO_RECIPIENT_SELECTED_ERR_MSG;
    selectBtnPlaceholder;
    selectedGroupsFromDropdown;
    displayGroupsChecked = false;
    parameterToExpandGetRecipients = RecipientListFilterConstants.GET_RECIPIENTS_EXPAND_PARAM;
    //private readonly moduleId;
    recipients;
    componentName = RecipientListFilterConstants.COMPONENT_NAME;
    defaultAddRecipientLabel = RecipientListFilterConstants.DEFAULT_RECIPIENT_LABEL;
    groupNameUndefinedErrMsg = RecipientListFilterConstants.GROUPNAME_UNDEFINED_ERR_MSG;
    modalBodyOptions = {
        size: "xl",
        centered: true,
        backdrop: "static"
    };
    getRecipientsByGroupSubscription;
    constructor(changeDetectorRef, recipientSettingsService, appControllerService, requestStatusService, modalService) {
        this.changeDetectorRef = changeDetectorRef;
        this.recipientSettingsService = recipientSettingsService;
        this.appControllerService = appControllerService;
        this.requestStatusService = requestStatusService;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.setConfigurableLabels();
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty("configurableLabel") && changes.configurableLabel.currentValue) {
            this.configurableLabel = changes.configurableLabel.currentValue;
            this.setConfigurableLabels();
        }
        if (changes && changes.hasOwnProperty("stepMetaRecipientGroups") && changes.stepMetaRecipientGroups.currentValue && changes.stepMetaRecipientGroups.currentValue.length > 0) {
            const groups = changes.stepMetaRecipientGroups.currentValue;
            this.stepMetaRecipientGroups = groups;
            this.getRecipients(groups);
        }
    }
    ngAfterViewInit() {
        this.changeDetectorRef.detectChanges();
        if (this.recipients) {
            this.filterRecipients(SharedConstants.FILTER_DEFAULT);
        }
    }
    onDisplayGroupsChangedChecked($event) {
        const displayGroupsChecked = $event.target.checked;
        if (displayGroupsChecked) {
            this.displayFilterGroups = true;
            this.selectedRecipientOptions.sort((a, b) => (a.consolidatedGroup?.localeCompare(b.consolidatedGroup)));
        }
        else {
            this.displayFilterGroups = false;
            this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
        }
    }
    onSelectGroupsChanged($event) {
        const groupSelected = $event.target.value;
        this.filterRecipients(groupSelected);
    }
    onSelectedRecipientChanged() {
        if (this.selectedRecipientFromDropdown !== undefined) {
            this.loadRecipient.emit(this.selectedRecipientFromDropdown);
            this.checkIfDisableStatus.emit();
        }
        else {
            this.appControllerService.showMessage(this.noRecipientSelectedErrMsg, AlertType.Warning);
        }
    }
    onAddBtnClicked() {
        const groupTypes = this.stepMetaRecipientGroups.length > 0 ? this.stepMetaRecipientGroups.map(group => group.groupType?.toLowerCase()?.trim()) : null;
        if (groupTypes.includes("internal")) {
            this.appControllerService.showMessage(`Cannot manually add ${this.configurableLabel} while the group type is set to internal in the step metadata.Please select a ${this.configurableLabel} from the dropdown below or contact your system administrator.`, AlertType.Warning);
            return;
        }
        const dialogRef = this.modalService.open(AddNewRecipientComponent, this.modalBodyOptions);
        dialogRef.componentInstance.title = this.configurableLabel;
        dialogRef.componentInstance.groupsFromMetaData = this.stepMetaRecipientGroups;
        dialogRef.componentInstance.jobId = +this.jobId;
        if (this.stepMetaRecipientGroups.length > 1) {
            dialogRef.componentInstance.showRecipientsGroupsDropdown = true;
        }
        else {
            dialogRef.componentInstance.showRecipientsGroupsDropdown = false;
        }
        dialogRef.result.then((newRecipient) => {
            if (newRecipient) {
                this.loadRecipient.emit(newRecipient);
                this.recipients.push(newRecipient);
                newRecipient.fullName = `${newRecipient.name} ${newRecipient.surname}`;
                newRecipient.consolidatedGroup = this.createConsolidatedGroups(newRecipient);
                this.selectedRecipientOptions.push(newRecipient);
                this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
            }
        });
    }
    resetComponent() {
        this.selectedRecipientFromDropdown = undefined;
        this.selectedGroupsFromDropdown = undefined;
        this.displayGroupsChecked = false;
        this.recipients = [];
        this.selectedRecipientOptions = [];
        this.getRecipients(this.stepMetaRecipientGroups);
    }
    populateGroupsDropDown() {
        this.stepMetaRecipientGroups.forEach((group) => {
            if (group.groupName) {
                this.selectedGroupOptions.push(group.groupName);
            }
            else {
                this.appControllerService.showMessage(this.groupNameUndefinedErrMsg, AlertType.Error);
            }
        });
    }
    setConfigurableLabels() {
        const label = this.configurableLabel;
        if (label !== undefined || label != null || label !== "") {
            this.addBtnPlaceholder = `Add ${label}`[0].toUpperCase() + `Add ${label}`.substr(1).toLowerCase();
            this.configurableLabelPlaceholder = `Select ${label}`[0].toUpperCase() + `Select ${label}`.substr(1).toLowerCase();
        }
        else {
            this.addBtnPlaceholder = this.defaultAddRecipientLabel;
        }
    }
    getRecipients(recipientGroups) {
        if (!this.stepMetaRecipientGroups.disableFilter) {
            this.getRecipientsByGroupSubscription =
                this.recipientSettingsService.getRecipientsByGroup(this.generateFilterObject(recipientGroups))
                    .subscribe({
                    next: (data) => {
                        this.requestStatusService.showBusySpinner("initialFilter");
                        this.populateGroupsDropDown();
                        this.setConfigurableLabels();
                        this.selectedRecipientOptions = [];
                        this.selectedRecipientFromDropdown = undefined;
                        this.changeDetectorRef.detectChanges();
                        this.populateRecipientsDropDown(data.recipients);
                        this.requestStatusService.removeBusySpinner("initialFilter");
                    },
                    error: (error) => {
                        this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
                    }
                });
        }
    }
    populateRecipientsDropDown(recipients) {
        this.recipients = recipients;
        this.recipients.forEach(recipient => {
            recipient.consolidatedGroup = this.createConsolidatedGroups(recipient);
            this.selectedRecipientOptions.push(recipient);
        });
        this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
        this.filterRecipients(SharedConstants.FILTER_DEFAULT);
        this.changeDetectorRef.detectChanges();
    }
    filterRecipients(groupSelected) {
        if (groupSelected === SharedConstants.FILTER_DEFAULT) {
            if (this.recipients) {
                this.selectedRecipientOptions = this.recipients.filter((recipient) => {
                    // tslint:disable-next-line:prefer-for-of
                    for (let i = 0; i < recipient.groups.length; i++) {
                        if (this.selectedGroupOptions.indexOf(recipient.groups[i].groupName) > 0) {
                            const nameOfGroup = this.selectedGroupOptions[this.selectedGroupOptions.indexOf(recipient.groups[i].groupName)];
                            for (const group of this.stepMetaRecipientGroups) {
                                if (group.groupName === nameOfGroup && group.groupType === recipient.groups[i].groupType) {
                                    if ((recipient.groups[i].groupType.toLowerCase() === "external" && recipient.jobId === +this.jobId) ||
                                        recipient.groups[i].groupType.toLowerCase() === "internal") {
                                        return recipient;
                                    }
                                }
                            }
                        }
                    }
                });
                if (this.selectedRecipientOptions.length === 1) {
                    this.selectedRecipientFromDropdown = this.selectedRecipientOptions[0];
                    this.onSelectedRecipientChanged();
                }
                else {
                    this.sortGroupsAlphabetically();
                }
                this.selectedGroupsFromDropdown = "All";
            }
        }
        else {
            this.selectedRecipientOptions = this.recipients.filter((recipient) => {
                // tslint:disable-next-line:prefer-for-of
                for (let i = 0; i < recipient.groups.length; i++) {
                    if (groupSelected === recipient.groups[i].groupName) {
                        const nameOfGroup = this.selectedGroupOptions[this.selectedGroupOptions.indexOf(recipient.groups[i].groupName)];
                        for (const group of this.stepMetaRecipientGroups) {
                            if (group.groupName === nameOfGroup && group.groupType === recipient.groups[i].groupType) {
                                if ((recipient.groups[i].groupType.toLowerCase() === "external" && recipient.jobId === +this.jobId) ||
                                    recipient.groups[i].groupType.toLowerCase() === "internal") {
                                    return recipient;
                                }
                            }
                        }
                    }
                }
            });
            this.selectedRecipientFromDropdown = this.selectedRecipientOptions[0];
            if (this.selectedRecipientFromDropdown) {
                this.onSelectedRecipientChanged();
                this.sortGroupsAlphabetically();
            }
        }
    }
    createConsolidatedGroups(recipient) {
        const groups = [];
        recipient.groups.forEach(group => groups.push(group.groupName));
        const consolidatedGroups = groups.join(", ");
        return consolidatedGroups;
    }
    sortGroupsAlphabetically() {
        if (this.displayFilterGroups) {
            this.selectedRecipientOptions.sort((a, b) => (a.consolidatedGroup?.localeCompare(b.consolidatedGroup)));
        }
        else {
            this.selectedRecipientOptions.sort((a, b) => (a.name?.localeCompare(b.name)));
        }
    }
    generateFilterObject(recipientGroups) {
        const recipientSelect = {
            jobId: this.jobId,
            moduleId: this.appControllerService.selectedModuleID,
            groups: []
        };
        if (recipientGroups.length > 0) {
            recipientGroups.forEach((group, i) => {
                const ggroup = {
                    groupType: group.groupType,
                    groupName: group.groupName
                };
                recipientSelect.groups.push(ggroup);
            });
        }
        return recipientSelect;
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: RecipientSettingsService },
        { type: AppControllerService },
        { type: RequestStatusService },
        { type: NgbModal }
    ];
    static propDecorators = {
        stepMetaRecipientGroups: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        disableAddRecipientBtn: [{ type: Input }],
        jobId: [{ type: Input }],
        loadRecipient: [{ type: Output }],
        checkIfDisableStatus: [{ type: Output }]
    };
};
RecipientSelectFilterComponent = __decorate([
    Component({
        selector: "app-recipient-select-filter",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], RecipientSelectFilterComponent);
export { RecipientSelectFilterComponent };
